import { motion } from 'framer-motion';

import { Skeleton, Typography } from '@recruit-robin/robin-theme/web-components';
import { AnimatePresence } from 'motion/react';
import { useRef } from 'react';
import { ChatListItemViewModel } from '../../model';
import { listItemAnimationVariants, useStyles } from './ListItem.styles';

const Group = ({ children }: { children: React.ReactNode }) => {
  const classes = useStyles();

  return (
    <div css={classes.group}>
      <AnimatePresence>{children}</AnimatePresence>
    </div>
  );
};

const ItemSkeleton = () => {
  const classes = useStyles();
  const headingLineWidth = useRef(Math.random() * 60 + 120);
  const supportingLabelLineWidth = useRef(Math.random() * 30 + 60);

  return (
    <motion.div
      css={[classes.item, classes.skeleton]}
      initial="initial"
      animate="animate"
      exit="exit"
      whileInView="inView"
      variants={listItemAnimationVariants}
      viewport={{ once: true }}>
      <Skeleton variant="text" font={(f) => f.heading[5]} width={headingLineWidth.current} />
      <Skeleton variant="text" font={(f) => f.supporting.label} width={supportingLabelLineWidth.current} />
    </motion.div>
  );
};

const GroupSkeleton = ({ length }: { length: number }) => {
  return Array.from({ length }).map((_, index) => <ItemSkeleton key={index} />);
};

export const ListItem = ({
  item,
  onClick,
  isSelected,
}: {
  item: ChatListItemViewModel;
  onClick?: () => void;
  isSelected?: boolean;
}) => {
  const classes = useStyles();

  return (
    <motion.div
      css={[classes.item, isSelected && classes.selected]}
      onClick={onClick}
      initial="initial"
      animate="animate"
      exit="exit"
      whileInView="inView"
      variants={listItemAnimationVariants}
      viewport={{ once: true }}>
      <Typography
        customCss={classes.title}
        variant={(v) => v.heading[5]}
        color={(c) => c.neutral.variant[80]}
        inline
        ellipsis>
        {item.jobTitle}
      </Typography>
      <Typography variant={(v) => v.supporting.label} color={(c) => c.neutral.variant[60]}>
        {item.owner}
      </Typography>
    </motion.div>
  );
};

Group.Skeleton = GroupSkeleton;
ListItem.Group = Group;
ListItem.Skeleton = ItemSkeleton;
